﻿

class UtmFacade {
    constructor(mode = `url`) {
      this.run()
      // Пока не используется
      this.mode = mode;
    }
  
    run() {
      const queryString = window.location.search;
      this.urlParams = new URLSearchParams(queryString);
      this.load()
    }
  
    save(utmData) {
      if (Object.keys(utmData).length) {
        const validUtmData = {};
  
        this.utmKeys.forEach(key => {
          if (key in utmData && utmData[key]) { 
            validUtmData[key] = utmData[key];
          }
        });
  
        localStorage.setItem(`utm_params`, JSON.stringify(validUtmData));
      }
    }
  
  
    get utmKeys() {
      const utmKeys = [
        `utm_source`,
        `utm_medium`, 
        `utm_campaign`, 
        `utm_term`, 
        `utm_content`
      ];
      return utmKeys;
    }
  
    get() {
      const utm = {};
    
      this.utmKeys.forEach((key) => {
        // не должны попадать пустые значенияе
        let utmMeta = this.urlParams.get(key);

        if (utmMeta) {
            utm[key] = this.urlParams.get(key);
        }
      
      });

      return utm;
    }
  
    
    load() {
      if(this.isEmpty()) return 
  
      this.save(this.get())
    }
  
    all() {
      let utm = {};
      
      if (!this.isEmptyStorage()) {
        utm = JSON.parse(localStorage.getItem(`utm_params`))
      }
      
      return utm;
    }
  
    has(key) {}
  
    find() {}
  
    isEmpty() {
      return Object.keys(this.get()).length ? false : true;
    }
  
    isEmptyStorage() {
      return localStorage.getItem(`utm_params`) ? false : true;
    }
  
   // question, what is it
    isAd() {}
  }
  

  export default new UtmFacade()